import { render, staticRenderFns } from "./finished.vue?vue&type=template&id=5ca6e7f7&scoped=true"
import script from "./finished.vue?vue&type=script&lang=ts"
export * from "./finished.vue?vue&type=script&lang=ts"
import style0 from "./finished.vue?vue&type=style&index=0&id=5ca6e7f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca6e7f7",
  null
  
)

export default component.exports